import React from 'react';

const Check = ({couleur = "#66BE63"}) => {
    return (
        <div style={{position: 'relative', width: '18px', height: '18px'}} className={"iconeCheck"}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                 style={{position: 'absolute', top: '0', left: '0'}}>
                <circle cx="9" cy="9" r="9" fill={couleur}/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                 style={{position: 'absolute', top: '1px', left: '1px'}}>
                <path d="M2.85742 8.20117L6.49397 11.8377L13.7671 4.56462" stroke="white" strokeWidth="2"/>
            </svg>
        </div>
    );
};

export default Check;
